import { z } from 'zod';

export interface AudioSettings {
  musicVolume: number;
  sfxVolume: number;
}

export const DEFAULT_AUDIO_SETTINGS: AudioSettings = {
  musicVolume: 0.35,
  sfxVolume: 0.7,
};

export const audioSettingsSchema = z.object({
  musicVolume: z.number().min(0).max(1),
  sfxVolume: z.number().min(0).max(1),
});

export function normalizeVolume(value: number): number {
  if (!Number.isFinite(value)) return 0;
  return Math.round(Math.min(1, Math.max(0, value)) * 100) / 100;
}

export function parseAudioSettings(raw: unknown): AudioSettings {
  const result = audioSettingsSchema.safeParse(raw);
  return result.success ? result.data : DEFAULT_AUDIO_SETTINGS;
}
